<template>
  <el-form
    ref="feesForSecurityForm"
    :model="model"
    :rules="rules"
    label-width="13em"
    label-position="left"
    class="fees-for-security-form"
  >
    <div class="el-form--inline">
    <BillingYm v-model="billingYm" :required="true" :searchCond="true" :mode="billingYmMode" :disabled="editMode" :autofocus="!editMode" />
    <BillToCode v-model="billToCode" :required="!searchMode" :searchCond="searchMode"
        :disabled="editMode" :autocomplete-list="autocompleteCustomerCodeSet" />
    </div>
    <el-divider />
    <div class="el-form--inline">
      <!-- <RouteCode v-model="routeCode" :initialize="true" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode && editMode" /> -->
      <RouteCode v-model="routeCode" :initialize="true" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" />
      <AirportCode v-model="destinationAirportCode" label="目的地" prop="destination_airport_code"
        :required="!searchMode" :disabled="editMode" :searchCond="searchMode" :autocomplete-list="autocompleteAirportCodeSet" />
    </div>
    <template v-if='formMode === "search"'>
      <div class="el-form--inline">
        <!-- <PaidPassengers v-model="paidPassengers" :required="!searchMode" :searchCond="searchMode"/> -->
        <Numeric v-model="paidPassengers" label="有償旅客数" prop="paid_passengers" :required="!searchMode" :searchCond="searchMode" :min="0" :max="999999" :step="1" :disabled="editDisabledMode && editMode" />
        <!-- <PaidCargoVolume v-model="paidCargoVolume" :required="!searchMode" :searchCond="searchMode"/> -->
        <Numeric v-model="paidCargoVolume" label="有償貨物量[kg]" prop="paid_cargo_volume" :required="!searchMode" :searchCond="searchMode" :min="0" :max="99999999" :step="1" :disabled="editDisabledMode && editMode" />
      </div>
    </template>
    <template v-else>
      <div class="el-form--inline">
        <!-- <PaidPassengers v-model="paidPassengers" :required="!searchMode" :searchCond="searchMode"/> -->
        <Numeric v-model="paidPassengers" label="有償旅客数" placeholder="0～999999" prop="paid_passengers" :required="!searchMode" :searchCond="searchMode" :min="0" :max="999999" :step="1" :disabled="editDisabledMode && editMode" />
        <!-- <PaidCargoVolume v-model="paidCargoVolume" :required="!searchMode" :searchCond="searchMode"/> -->
        <Numeric v-model="paidCargoVolume" label="有償貨物量[kg]" placeholder="0～99999999" prop="paid_cargo_volume" :required="!searchMode" :searchCond="searchMode" :min="0" :max="99999999" :step="1" :disabled="editDisabledMode && editMode" />
      </div>
    </template>
    <el-divider />
    <div class="el-form--inline">
      <Taxation v-model="taxation" :initialize="true" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode && editMode" />
      <template v-if='formMode === "search"'>
        <Numeric v-model="tax" label="税率[%]" prop="tax" :required="!searchMode" :disabled="editMode" :searchCond="searchMode" :min="0" :max="99" :step="1" />
      </template>
      <template v-else-if='formMode === "edit"'>
        <Numeric v-model="tax" label="税率[%]" placeholder="0～99" prop="tax" :required="!searchMode" :disabled="editMode" :searchCond="searchMode" :min="0" :max="99" :step="1" />
      </template>
      <template v-else>
        <Blank />
      </template>
    </div>
    <div class="el-form--inline">
      <Numeric v-model="passengerFee" label="単価(旅客数)[円/人]" prop="passenger_fee"
        :required="!searchMode" :searchCond="searchMode" :min="0" :max="9999" :disabled="editDisabledMode && editMode" />
      <Numeric v-model="cargoVolumeFee" label="単価(貨物量)[円/t]" prop="cargo_volume_fee"
        :required="!searchMode" :searchCond="searchMode" :min="0" :max="9999" :disabled="editDisabledMode && editMode" />
    </div>
    <!--2022/05/06髙森追記-->
    <div class="el-form--inline">
      <Numeric v-model="passengerSecurityFeeWithTax" label="旅客数保安料[円]" prop="passenger_security_fee_with_tax"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
      <Numeric v-model="cargoSecurityFeeWithTax" label="貨物量保安料[円]" prop="cargo_security_fee_with_tax"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
    </div>
    <!-- -->
    <div class="el-form--inline">
      <Numeric v-model="securityFeeWithoutTax" label="保安料(税抜)[円]" prop="security_fee_without_tax"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
      <Numeric v-model="securityFeeTax" label="保安料(税)[円]" prop="security_fee_tax"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
    </div>
    <div class="el-form--inline">
      <Numeric v-model="securityFeeWithTax" label="保安料(税込)[円]" prop="security_fee_with_tax"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
      <Blank />
      <template v-if='formMode === "search"'>
        <div class="parent_Box">
          <div class="child_Box">
            <el-checkbox v-model="manualDataOnly" v-if="searchMode" :searchCond="searchMode" >検索結果に補正登録データのみ表示する</el-checkbox>
          </div>
          <div class="child_Box">
            <el-checkbox v-model="automaticDataOnly" v-if="searchMode" :searchCond="searchMode" >検索結果に自動入力データのみ表示する</el-checkbox>
          </div>
        </div>
      </template>
    </div>
  </el-form>
</template>

<script>
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import BillToCode from '@/components/molecules/form/autocomplete/BillToCode.vue'
import RouteCode from '@/components/molecules/form/select/RouteCode.vue'
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
// import Fee from '@/components/molecules/form/text/Fee.vue'
// import Tax from '@/components/molecules/form/number/Tax.vue'
import Taxation from '@/components/molecules/form/select/Taxation.vue'
// import PaidPassengers from '@/components/molecules/form/number/PaidPassengers.vue'
// import PaidCargoVolume from '@/components/molecules/form/number/PaidCargoVolume.vue'
import Numeric from '@/components/molecules/form/number/Numeric.vue'

export default {
  components: {
    BillingYm,
    BillToCode,
    RouteCode,
    AirportCode,
    // Fee,
    // Tax,
    Numeric,
    Taxation
    // PaidPassengers,
    // PaidCargoVolume
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    billingYmMode: {
      type: String,
      default: 'search'
    },
    editDisabledMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    billingYm: {
      get () {
        return this.model.billing_ym
      },
      set (billingYm) {
        const form = { ...this.model }
        form.billing_ym = billingYm
        this.$emit('input', form)
      }
    },
    billToCode: {
      get () {
        return this.model.bill_to_code
      },
      set (billToCode) {
        const form = { ...this.model }
        form.bill_to_code = billToCode
        this.$emit('input', form)
      }
    },
    routeCode: {
      get () {
        return this.model.route_code
      },
      set (routeCode) {
        const form = { ...this.model }
        form.route_code = routeCode
        this.$emit('input', form)
      }
    },
    destinationAirportCode: {
      get () {
        return this.model.destination_airport_code
      },
      set (destinationAirportCode) {
        const form = { ...this.model }
        form.destination_airport_code = destinationAirportCode
        this.$emit('input', form)
      }
    },
    paidPassengers: {
      get () {
        return this.model.paid_passengers
      },
      set (paidPassengers) {
        const form = { ...this.model }
        form.paid_passengers = paidPassengers
        this.$emit('input', form)
      }
    },
    paidCargoVolume: {
      get () {
        return this.model.paid_cargo_volume
      },
      set (paidCargoVolume) {
        const form = { ...this.model }
        form.paid_cargo_volume = paidCargoVolume
        this.$emit('input', form)
      }
    },
    // 2022/05/06髙森追記 旅客数保安料
    passengerSecurityFeeWithTax: {
      get () {
        return this.model.passenger_security_fee_with_tax
      },
      set (passengerSecurityFeeWithTax) {
        const form = { ...this.model }
        form.passenger_security_fee_with_tax = passengerSecurityFeeWithTax
        this.$emit('input', form)
      }
    },
    // 貨物量保安料
    cargoSecurityFeeWithTax: {
      get () {
        return this.model.cargo_security_fee_with_tax
      },
      set (cargoSecurityFeeWithTax) {
        const form = { ...this.model }
        form.cargo_security_fee_with_tax = cargoSecurityFeeWithTax
        this.$emit('input', form)
      }
    },
    // ここまで髙森修正
    securityFeeWithoutTax: {
      get () {
        return this.model.security_fee_without_tax
      },
      set (securityFeeWithoutTax) {
        const form = { ...this.model }
        form.security_fee_without_tax = securityFeeWithoutTax
        this.$emit('input', form)
      }
    },
    securityFeeTax: {
      get () {
        return this.model.security_fee_tax
      },
      set (securityFeeTax) {
        const form = { ...this.model }
        form.security_fee_tax = securityFeeTax
        this.$emit('input', form)
      }
    },
    securityFeeWithTax: {
      get () {
        return this.model.security_fee_with_tax
      },
      set (securityFeeWithTax) {
        const form = { ...this.model }
        form.security_fee_with_tax = securityFeeWithTax
        this.$emit('input', form)
      }
    },
    tax: {
      get () {
        return this.model.tax
      },
      set (tax) {
        const form = { ...this.model }
        form.tax = tax
        this.$emit('input', form)
      }
    },
    taxation: {
      get () {
        return this.model.taxation
      },
      set (taxation) {
        const form = { ...this.model }
        form.taxation = taxation
        this.$emit('input', form)
      }
    },
    passengerFee: {
      get () {
        return this.model.passenger_fee
      },
      set (passengerFee) {
        const form = { ...this.model }
        form.passenger_fee = passengerFee
        this.$emit('input', form)
      }
    },
    cargoVolumeFee: {
      get () {
        return this.model.cargo_volume_fee
      },
      set (cargoVolumeFee) {
        const form = { ...this.model }
        form.cargo_volume_fee = cargoVolumeFee
        this.$emit('input', form)
      }
    },
    manualDataOnly: {
      get () {
        return this.model.manual_data_only
      },
      set (manualDataOnly) {
        const form = { ...this.model }
        form.manual_data_only = manualDataOnly
        this.$emit('input', form)
        if (manualDataOnly === true) {
          form.automatic_data_only = false
        }
      }
    },
    automaticDataOnly: {
      get () {
        return this.model.automatic_data_only
      },
      set (automaticDataOnly) {
        const form = { ...this.model }
        form.automatic_data_only = automaticDataOnly
        this.$emit('input', form)
        if (automaticDataOnly === true) {
          form.manual_data_only = false
        }
      }
    },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
    // editDisabledMode: {
    //   get () {
    //     return this.model.regist_type === '1' || parseInt(this.model.billing_ym) < parseInt(this.getDefaultBillingYm())
    //   }
    // }
  },
  mounted () {
  },
  methods: {
    clearFields () {
      this.$refs.feesForSecurityForm.resetFields()
      this.billingYm = this.getDefaultBillingYm()
      if (this.searchMode) {
        this.model.manual_data_only = false
        this.model.automatic_data_only = false
      }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.feesForSecurityForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fees-for-security-form {
  .el-form--inline {
    display: flex;
    justify-content: space-between;
    // margin-left: 10px;
  }
  .el-form-item {
    width: 60em;
  }
  // ::v-deep .el-form-item__content .el-input__inner {
  //   width: 12em;
  // }
  .parent_Box{
    padding-right: 15px
  }
}

</style>
